import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Stack, Typography } from '@mui/material';
import { useContext } from 'react';
import { EntityControlTransactionsView } from '../../Entity';
import { EntityGroupControlContext } from '../../EntityGroup/Reducers/EntityGroupControlReducer';
import { useDeviceControlChannelActions } from '../../data/UseDeviceControlChannelActions';
const debug = process.env.REACT_APP_DEBUG && false;
export const EntityProgrammeSetControlInternal = ({ entity }) => {
    const { state, dispatch } = useContext(EntityGroupControlContext);
    const { Entities, EntityStates } = state;
    const x = useDeviceControlChannelActions({ canaryString: 'EntityControlState (EntityProgrammeSet)', loadDeviceConfigs: true });
    const entityTransactions = Object.values(EntityStates ?? {});
    debug && console.log(`INFO: EntityProgrammeSetControlInternal rerendered with`, entityTransactions);
    return (_jsxs(Stack, { children: [_jsxs(Typography, { variant: "h5", children: [entity?.name ?? '', " transactions"] }), _jsx(Stack, { children: _jsx(EntityControlTransactionsView, { entityTransactions }) })] }));
};
